import styled from "styled-components";

export const AutocompleteContainer = styled.div`
  background-color: default;
  font-family: "Open Sans", sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeight.md};
  max-width: 100%;
  width: 375px;
`;
